// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__25H5q","disabled":"FileBtn_disabled__1lUik","warn":"FileBtn_warn__2jegy","fade":"FileBtn_fade__2kiZs"};